import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import MainPage from '../components/MainPage';
import getOperators from '../actions/api/operators/getOperators';
import config from '../config';

class MapContainer extends Component {
  constructor(props) {
    super(props);
    const {
      dispatch = null,
      apiToken,
      searchOptions,
      targetGroupId: groupId = null,
    } = props;
    dispatch({ type: 'OPEN_MAP' });

    const accountStatuses = config.searchAccountStatus.enable;
    const options = {
      accountStatuses,
      ...searchOptions,
      groupIds: groupId ? [groupId] : null,
    };
    dispatch(getOperators(apiToken, options));
  }

  render() {
    const { isLogin } = this.props;
    return (!isLogin && <Redirect to="/login" />) || <MainPage />;
  }
}

MapContainer.propTypes = {
  isLogin: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  apiToken: PropTypes.string.isRequired,
  searchOptions: PropTypes.object.isRequired,
  targetGroupId: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  searchOptions: state.operator.searchOptions,
  fullScreenMode: state.main.fullScreenMode,
  targetGroupId: state.main.targetGroupId,
});

export default connect(mapStateToProps)(MapContainer);
